export default class Freshdesk {

    constructor(axios, baseUrl) {
        this.axios = axios;
        this.baseUrl = `${baseUrl}/Freshdesk`;

    }

    getTickets() {

        let self = this;
        return self.axios.get(`${self.baseUrl}/tickets`, self.user)
    
    }
}




// WEBPACK FOOTER //
// ./src/services/FreshdeskService.js